import { apiHttpService } from './apiHttpService';
import { ListResponse } from '../domains/app';
import {
  FilledAnswer,
  Language,
  Questionnaire,
  QuestionnaireRequest,
  QuestionSeries,
} from '../features/Questionnaires/questionnaires';

export const fetchListQuestionnaire = (
  pageSize: number,
  page: number,
  search?: string,
): Promise<ListResponse<Questionnaire>> => {
  return apiHttpService
    .get(
      `/api/Questionnaire?pageSize=${pageSize}&page=${page}${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response) => response.data);
};

export const createQuestionnaire = (
  question: Questionnaire,
): Promise<Questionnaire> => {
  return apiHttpService
    .post(
      `/api/Questionnaire?languageId=${question.languageId}`,
      question,
    )
    .then((response) => response.data);
};

export const deleteQuestionnaire = (id: string): Promise<Questionnaire> => {
  return apiHttpService
    .delete(`/api/Questionnaire/${id}`)
    .then((response) => response.data);
};

export const fetchListLanguges = (): Promise<Language[]> => {
  return apiHttpService
    .get(`/api/language`)
    .then((response) => response.data);
};

export const fetchQuestionnaire = (
  id: string,
  languageId: string,
): Promise<Questionnaire> => {
  return apiHttpService
    .get(`/api/Questionnaire/${id}?languageId=${languageId}`)
    .then((response) => response.data);
};

export const createQuestionSeries = (
  questionnaireId: string,
  languageId: string,
  questionSeries: QuestionSeries,
): Promise<QuestionSeries> => {
  return apiHttpService
    .post(
      `/api/Questionnaire/${questionnaireId}/questionserie?languageId=${languageId}`,
      questionSeries,
    )
    .then((response) => response.data);
};

export const deleteQuestionSeries = (id: string): Promise<QuestionSeries> => {
  return apiHttpService
    .delete(`/api/Questionnaire/serie/${id}`)
    .then((response) => response.data);
};

export const toggleQuestionStatus = (
  questionnaireId: string,
): Promise<boolean> => {
  return apiHttpService
    .post(`/api/Questionnaire/${questionnaireId}/togglepublish`)
    .then((response) => response.data);
};

export const sendQuestionnaire = (
  questionnaireId: string,
  spaceId: string,
  sentByPersonId: string,
  userIds: string[],
): Promise<Questionnaire> => {
  return apiHttpService
    .post(
      `/api/Questionnaire/${questionnaireId}/request?spaceId=${spaceId}&sentByPersonId=${sentByPersonId}`,
      userIds,
    )
    .then((response) => response.data);
};

export const fetchPublishedQuestionnaire = (): Promise<Questionnaire[]> => {
  return apiHttpService
    .get(`/api/Questionnaire/published`)
    .then((response) => response.data);
};

export const fetchQuestionnaireRequests = (
  personId: string,
): Promise<QuestionnaireRequest[]> => {
  return apiHttpService
    .get(`/api/Questionnaire/request/${personId}`)
    .then((response) => response.data);
};

export const getQuestionnaireScript = (id: string): Promise<any> => {
  return apiHttpService
    .get(`/api/Questionnaire/${id}/scoring/script`)
    .then((response) => response.data);
};

export const questionnaireScriptVerify = (
  id: string,
  script: string,
): Promise<any> => {
  return apiHttpService
    .post(`/api/Questionnaire/${id}/scoring/script/verify`, script, {
      responseType: 'text',
    })
    .then((response) => response.data);
};

export const questionnaireScriptCreate = (
  id: string,
  script: string,
): Promise<any> => {
  return apiHttpService
    .post(`/api/Questionnaire/${id}/scoring/script`, script, {
      responseType: 'text',
    })
    .then((response) => response.data);
};

export const fillQuestionnaire = (
  requestId: string,
  answers: FilledAnswer[],
): Promise<any> => {
  return apiHttpService
    .post(`/api/Questionnaire/request/${requestId}/fill`, {
      filledAnswers: answers,
    })
    .then((response) => response.data);
};

export const calculateQuestionnaireResult = (
  fillId: string,
  save?: boolean,
): Promise<any> => {
  return apiHttpService
    .get(
      `/api/Questionnaire/fill/${fillId}/calculate${
        save !== undefined ? `?save=${save}` : ''
      }`,
    )
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  fetchListQuestionnaire,
  createQuestionnaire,
  deleteQuestionnaire,
  fetchListLanguges,
  fetchQuestionnaire,
  createQuestionSeries,
  deleteQuestionSeries,
  toggleQuestionStatus,
  fetchPublishedQuestionnaire,
  sendQuestionnaire,
  fetchQuestionnaireRequests,
  getQuestionnaireScript,
  questionnaireScriptVerify,
  questionnaireScriptCreate,
  fillQuestionnaire,
};
